import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });

    // Report to backend
    const payload = {
      type: 'react_crash',
      message: error?.message || String(error),
      stack: error?.stack?.slice(0, 800) || '',
      component: errorInfo?.componentStack?.slice(0, 500) || '',
      url: window.location.href,
      userAgent: navigator.userAgent.slice(0, 200),
      timestamp: new Date().toISOString(),
    };

    const apiUrl = process.env.REACT_APP_API_URL || 'https://api.instacamgirls.com';
    const fullUrl = apiUrl.startsWith('http') ? apiUrl : 'https://' + apiUrl;
    fetch(`${fullUrl}/api/error-report`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {});

    // Also log to console for debugging
    console.error('[ErrorBoundary]', error, errorInfo);
    // Show error in title for remote debugging
    try { document.title = '[ERR] ' + (error?.message || String(error)).slice(0,60); } catch(e) {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center',
          justifyContent:'center', minHeight:'60vh', p:4, textAlign:'center' }}>
          <BugReportIcon sx={{ fontSize:64, color:'#FF4196', mb:2 }} />
          <Typography variant="h5" sx={{ fontWeight:800, mb:1 }}>
            Something went wrong
          </Typography>
          <Typography sx={{ color:'#888', mb:3 }}>
            We've been notified and are fixing it. Try refreshing the page.
          </Typography>
          {this.state.error && (
            <Typography sx={{ color:'#ff6b6b', fontSize:'11px', fontFamily:'monospace',
              maxWidth:'90vw', wordBreak:'break-all', mb:2, p:1, background:'#1a1a1a', borderRadius:'4px' }}>
              {this.state.error.message || String(this.state.error)}
            </Typography>
          )}
          <Button variant="contained"
            sx={{ background:'linear-gradient(45deg,#FF6B6B,#FF2BAA)', borderRadius:'50px',
              color:'#fff', fontWeight:700 }}
            onClick={() => window.location.reload()}>
            Refresh Page
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
